import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-arch-targets-modal',
  templateUrl: './arch-targets-modal.component.html',
  styleUrls: ['./arch-targets-modal.component.scss'],
})
export class ArchTargetsModalComponent implements AfterViewInit {
  @Input() isOpen: boolean = false;
  @Input() data: any[] = [];
  @Output() close = new EventEmitter<void>();

  columns: any[] = [];

  @ViewChild('archTypesCellTemplate') archTypesCellTemplate!: TemplateRef<any>;
  @ViewChild('targetBookingCellTemplate') targetBookingCellTemplate!: TemplateRef<any>;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.columns = [
      { field: 'architectureTypes', header: 'Architectures', align: 'left', cellTemplate: this.archTypesCellTemplate },
      { field: 'architectureBookingsToBeSold', header: 'Target Booking', align: 'left', cellTemplate: this.targetBookingCellTemplate },
    ];
    this.cdr.detectChanges();
  }
}
